import type { ReactNode } from 'react';

type ContactDetailWorkspaceProps = {
  header?: ReactNode;
  overview?: ReactNode;
  activity?: ReactNode;
  emptyState?: ReactNode;
  loading?: boolean;
};

export function ContactDetailWorkspace({
  header,
  overview,
  activity,
  emptyState,
  loading = false,
}: ContactDetailWorkspaceProps) {
  return (
    <section className="contact-detail-workspace" aria-label="Карточка контакта">
      {loading ? (
        <div className="contact-detail-workspace__state" aria-busy="true">
          Загружаем карточку контакта…
        </div>
      ) : !header ? (
        <div className="contact-detail-workspace__state">{emptyState}</div>
      ) : (
        <>
          <header className="contact-detail-workspace__header">{header}</header>
          <div className="contact-detail-workspace__body">
            <div
              className="contact-detail-workspace__overview"
              role="region"
              aria-label="Обзор контакта"
              tabIndex={0}
            >
              {overview}
            </div>
            <div
              className="contact-detail-workspace__activity"
              role="region"
              aria-label="История взаимодействий"
              tabIndex={0}
            >
              {activity}
            </div>
          </div>
        </>
      )}
    </section>
  );
}
